import script from "./MetricTimeWindowSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./MetricTimeWindowSettings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__